export enum Shortcut {
    PATIENT_SEARCH_SPOTLIGHT = 'mod+p',
    WALK_IN_MODAL = 'mod+o',
}
